$( document ).ready(function(){
  $('.testimonial-grid-content').slick({
    arrows: false,
    dots: true,
    slidesToShow: 1,
    infinite: true,
    mobileFirst: true, 
    centerMode: true,
    adaptiveHeight: true,
    centerPadding: '20px',
    responsive: [
       {
          breakpoint: 749,
          settings: "unslick"
       }
    ]
  });
  $('.testimonial-grid-content').slick('slickGoTo',1);
});